import styled from 'styled-components';

import { Breakpoint, Color, FontWeight, Grid } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { AddToFavouriteBadge } from '../addToFavouriteBadge/addToFavouriteBadge.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { SlideProps } from './fullscreenSlider.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const Slide: StyledComponent<'div', SlideProps> = styled.div<SlideProps>`
  width: 100%;
  height: ${({ $slideHeight }: SlideProps): string => $slideHeight};
  background-image: url(${({ $backgroundImage }: SlideProps): string => $backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 96px 40px;
  position: relative;

  @media ${Breakpoint.Tablet} {
    padding: 88px 32px;
  }

  @media ${Breakpoint.Mobile} {
    padding: 88px 20px;
  }
`;

export const SwiperWrapper: StyledComponent<'div'> = styled.div``;

export const TopOverlayMask: StyledComponent<'div'> = styled.div`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 50.95%, rgba(0, 0, 0, 0) 100%);
  height: 200px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
`;

export const ChildrenContainer: StyledComponent<'div'> = styled.div`
  position: relative;
`;

export const StyledAddToFavouriteBadge: StyledComponent<typeof AddToFavouriteBadge> = styled(AddToFavouriteBadge)`
  position: absolute;
  bottom: 40px;
  left: 40px;

  @media ${Breakpoint.Tablet} {
    bottom: 32px;
    left: 32px;
  }

  @media ${Breakpoint.Mobile} {
    bottom: 20px;
    left: 20px;
  }
`;

export const Header: StyledComponent<'h2'> = styled.h2`
  font-weight: ${FontWeight.Medium};
  font-size: 40px;
  line-height: 44px;
  letter-spacing: -0.01em;
  color: ${Color.White};
  max-width: ${Grid.DesktopHalf};
  margin-bottom: 32px;
`;

export const MobileContentContainer: StyledComponent<'div'> = styled.div`
  background-color: ${Color.Gray200};
  padding: 40px 20px;
  height: 100%;
`;

export const MobileHeader: StyledComponent<'h2'> = styled.h2`
  font-weight: ${FontWeight.Medium};
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
  margin-bottom: 32px;
`;

export const ButtonContainer: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  @media ${Breakpoint.SmallMobile} {
    display: flex;
    flex-shrink: 0;
  }
`;

export const ButtonWrapper: StyledComponent<'div'> = styled.div`
  display: flex;

  ${ButtonContainer} + ${ButtonContainer} {
    margin-left: 10px;
  }
`;
